// src/app/store.js

/**
 * Configures the Redux store with:
 * - rootReducer including persist support
 * - RTK Query middleware for userApi and loginApi
 * - persistStore for redux-persist
 */

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { persistStore } from "redux-persist";

// RTK Query APIs
import { userApi } from "../features/auth/userApi";
import { loginApi } from "../features/auth/loginApi";

// Create Redux store
const store = configureStore({
  reducer: rootReducer,

  // Custom middleware setup
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable to allow non-serializable values in persist (like Dates, Promises)
    }).concat(
      userApi.middleware, // RTK Query auto-generated middleware
      loginApi.middleware
    ),
});

// Create a persistor to control persistence
export const persistor = persistStore(store);

// Export the store as default
export default store;
